import React, { ReactDOM, Suspense } from 'lib/react';
import './index.css';
import { Provider, persistStore, PersistGate } from 'lib/redux';
import { EVThemeProvider } from 'lib/components';
import configureStore from './store/ConfigureStore';
import App from './App';
import './i18n';
import './googleTagManager';
import './fullstory';
import './gainsightPXTag';
import Interceptor from './fetchInterceptor';
import setFeatureFlag from './features/featureFlag/featureFlag.actions';

const store = configureStore();
const persistor = persistStore(store);

const render = (elementId, props) => {
  ReactDOM.render(
    <Suspense
      fallback={(
        <>
          loading...
        </>
      )}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <EVThemeProvider classPrefix="myev">
            <App {...props} />
          </EVThemeProvider>
        </PersistGate>
      </Provider>
    </Suspense>,
    document.getElementById(elementId),
  );
};

window.myev = (elementId, props = {}) => ({
  mount: () => {
    const { setFullscreen, fetchIntercept, featureFlag = {} } = props;

    /**
     * call setFullscreen() method received from viewpoint to hide viewpoint sidebar and viewpoint header.
     */
    if (setFullscreen) setFullscreen();
    /**
     * if props.fetchIntercept is empty, add your own fetch-interceptor.
     */
    store.dispatch(setFeatureFlag(featureFlag));
    if (!fetchIntercept) {
      Interceptor().then(({ register }) => {
        register();
        render(elementId, props);
      });
    } else render(elementId, props);
  },
  unmount: () => ReactDOM.unmountComponentAtNode(document.getElementById(elementId)),
});
